import * as jQuery from 'jquery';

import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { PrerollCreativeComponent } from '../preroll-creative/preroll-creative.component';

@Component({
	selector: 'app-video-creative-r7',
	styleUrls: ['./video-creative-r7.component.css'],
	templateUrl: './video-creative-r7.component.html'
})
export class VideoCreativeR7Component extends PrerollCreativeComponent implements OnInit, AfterViewInit, OnChanges {
	@Input() videoCreativeInputData: any;
	@Input() isSocial: boolean;
	@Input() isPreroll: boolean;
	@Input() isRadio: boolean;
	@Input() engagements: number;
	@Input() likes: number;
	@Input() reactions: number;
	@Input() shares: number;
	@Input() saves: number;
	@Input() comments: number;
	@Input() legend: any;
	@Input() sectionclass: any;
	@ViewChild('iframeRef') iframeRef: ElementRef;

	public iFrameUrl: any;
	public firstSectionClass;
	public secondSectionClass;
	public updatediFrameUrl: any;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected sanitizer: DomSanitizer
	) {
		super(analyticsService, analyticsDataModel, cdr);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.setProperties();
			this.setData(this.videoCreativeData);
		});
	}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
		if (!this.isSocial) {
			this.volumeclick();
			this.controlsOptions(this.primaryColor, this.defaultColor);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.videoCreativeInputData) {
			this.setProperties();
			this.setData(this.videoCreativeData);
		}
	}

	ngOnInit(): void {
		this.firstSectionClass = this.sectionclass.split(' ')[1];
		this.secondSectionClass = this.sectionclass.split(' ')[2];
		if (this.isSocial) {
			this.setProperties();
		} else {
			this.setProperties();
			super.ngOnInit();
		}
	}

	setProperties(): void {
		if (this.isSocial) {
			this.videoCreativeData = this.videoCreativeInputData;
			this.showLoad = false;
			this.hasData = true;
			this.defaultColor = this.primaryColor;
			if (!UtilityService.isUndefinedOrNull(this.videoCreativeData.iframeUrl)) {
				this.updatediFrameUrl = this.videoCreativeData.iframeUrl.replace(
					/width="([^"]+)"/g,
					'width="100%" id="iframeRef" scrolling="no"'
				);
			}
			this.iFrameUrl = this.sanitizer.bypassSecurityTrustHtml(this.updatediFrameUrl);
			this.setDisplayProperties = {
				audioURL: '',
				click_rate: parseFloat(this.videoCreativeData.clickRate).toFixed(2),
				clicks: this.videoCreativeData.clicks,
				impressions: this.videoCreativeData.impressions,
				mp4: null,
				name: this.videoCreativeData.creativeName,
				percent_rate_100: parseFloat(this.videoCreativeData.percentRate100).toFixed(2),
				percent_rate_25: parseFloat(this.videoCreativeData.percentRate25).toFixed(2),
				percent_rate_50: parseFloat(this.videoCreativeData.percentRate50).toFixed(2),
				percent_rate_75: parseFloat(this.videoCreativeData.percentRate75).toFixed(2),
				percent_value_100: this.videoCreativeData.percentValue100,
				percent_value_25: this.videoCreativeData.percentValue25,
				percent_value_50: this.videoCreativeData.percentValue50,
				percent_value_75: this.videoCreativeData.percentValue75,
				engagements: this.engagements,
				likes: this.likes,
				comments: this.comments,
				reactions: this.reactions,
				shares: this.shares,
				saves: this.saves,
				thumbnail: this.videoCreativeData.creativeThumbnail
			};
		} else {
			this.videoCreativeData = [];
			const creativeObj = {
				'100_percent_rate': parseFloat(this.videoCreativeInputData.percentRate100).toFixed(2),
				'100_percent_value': this.videoCreativeInputData.percentValue100,
				'25_percent_rate': parseFloat(this.videoCreativeInputData.percentRate25).toFixed(2),
				'25_percent_value': this.videoCreativeInputData.percentValue25,
				'50_percent_rate': parseFloat(this.videoCreativeInputData.percentRate50).toFixed(2),
				'50_percent_value': this.videoCreativeInputData.percentValue50,
				'75_percent_rate': parseFloat(this.videoCreativeInputData.percentRate75).toFixed(2),
				'75_percent_value': this.videoCreativeInputData.percentValue75,
				click_rate: parseFloat(this.videoCreativeInputData.clickRate).toFixed(2),
				clicks: this.videoCreativeInputData.clicks,
				impressions: this.videoCreativeInputData.impressions,
				media_files: this.videoCreativeInputData.mediaFiles,
				mp4: this.videoCreativeInputData.creativeVideo,
				audioURL: this.videoCreativeInputData.audioURL,
				name: this.videoCreativeInputData.creativeName,
				thumbnail: this.videoCreativeInputData.creativeThumbnail,
				youtube_verified_imprs: this.videoCreativeInputData.youtubeVerifiedImprs,
				youtube_verified_imprs_rate: this.videoCreativeInputData.youtubeVerifiedImprsRate
			};
			this.videoCreativeData.push(creativeObj);
		}
	}

	requestPrerollData(): void {
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.hasData = true;
				this.setData(res.data);
			} else {
				this.hasData = false;
				this.displayData = [];
				this.carouselItemsLength = 0;
			}
		});
	}

	controlsOptions(primaryColor?: any, defaultColor?: any): void {
		const media = document.getElementById('preRollvideo');
		let gettheVideoTotalDuration;
		let checkfor0Percentage;
		let checkfor25Percentage;
		let checkfor50Percentage;
		let checkfor75Percentage;
		let checkfor100Percentage;
		// tslint:disable-next-line: only-arrow-functions
		const isPlaying = function (e: any): void {
			gettheVideoTotalDuration = jQuery('#preRollvideo')[0].duration;
			checkfor0Percentage = 0 / 4;
			checkfor25Percentage = gettheVideoTotalDuration / 4;
			checkfor50Percentage = parseFloat(checkfor25Percentage) * 2;
			checkfor75Percentage = parseFloat(checkfor25Percentage) * 3;
			checkfor100Percentage = parseFloat(checkfor25Percentage) * 4;
			jQuery('#pauseBtn').show();
			jQuery('#playBtn').hide();
		};
		// tslint:disable-next-line: only-arrow-functions
		const onPause = function (e: any): void {
			jQuery('#pauseBtn').hide();
			jQuery('#playBtn').show();
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime === gettheVideoTotalDuration) {
				jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor });

				jQuery('#percent0').css('color', '#213038');
				jQuery('#percent25').css('color', '#213038');
				jQuery('#percent50').css('color', '#213038');
				jQuery('#percent75').css('color', '#213038');
				jQuery('#percent100').css('color', '#213038');
			}
		};
		// tslint:disable-next-line: only-arrow-functions
		const onTimeUpdate = function (e: any): void {
			jQuery('#svg_0Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_25Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			jQuery('#svg_0Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1 });
			jQuery('#percent0').css('color', '#213038');
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor25Percentage) {
				jQuery('#svg_25Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				jQuery('#svg_25Percent').animate(
					{ opacity: 1 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
				jQuery('#percent25').css('color', '#213038');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor25Percentage) {
				jQuery('#percent25').css('color', '#607d8b');
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor50Percentage) {
				jQuery('#svg_50Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 0.1 });
				jQuery('#svg_50Percent').animate(
					{ opacity: 1 },
					{
						duration: checkfor25Percentage * 1000,
						easing: 'linear'
					}
				);
				jQuery('#percent50').css('color', '#213038');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor50Percentage) {
				jQuery('#percent50').css('color', '#607d8b');
				jQuery('#svg_50Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_75Percent').css({ backgroundColor: defaultColor, color: primaryColor });
				jQuery('#svg_100Percent').css({ backgroundColor: defaultColor, color: primaryColor });
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor75Percentage) {
				jQuery('#svg_75Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1 });
				jQuery('#percent75').css('color', '#213038');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor75Percentage) {
				jQuery('#percent75').css('color', '#607d8b');
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime >= checkfor100Percentage) {
				jQuery('#svg_100Percent').css({ backgroundColor: primaryColor, color: primaryColor, opacity: 1 });
				jQuery('#percent100').css('color', '#213038');
				jQuery('#playBtn').show();
				jQuery('#pauseBtn').hide();
			}
			if (jQuery('#preRollvideo')[0] && jQuery('#preRollvideo')[0].currentTime < checkfor100Percentage) {
				jQuery('#percent100').css('color', '#607d8b');
			}
		};
		if (media) {
			media.addEventListener('playing', isPlaying, false);
			media.addEventListener('pause', onPause, false);
			media.addEventListener('timeupdate', onTimeUpdate, false);
		}
	}
}
